
import { IPlopReport, IPlopReportData, IPlopReportItem, IPlopReportsParams, IPlopStats, IPlopStatsParams, ITableRes } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants';

export const plopAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_plopReports: builder.query<ITableRes<IPlopReportItem>, IPlopReportsParams>({
      query: (params) => ({
        url: '/plop-reports/',
        params,
      }),
      providesTags: ['plop-reports'],
    }),
    GET_plopReportById: builder.query<IPlopReport, string>({
      query: (id) => {
        return {
          url: `/plop-reports/${id}/`,
        }
      },
      providesTags: ['plop-reports'],
    }),
    POST_plopReport: builder.mutation<IPlopReport, IPlopReport>({
      query: (body) => ({
        url: `/plop-reports/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['plop-reports'],
    }),
    PATCH_plopReport: builder.mutation<IPlopReport, { id: string; body: IPlopReportData }>({
      query: ({ id, body }) => ({
        url: `/plop-reports/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['plop-reports', 'plop-report'],
    }),
    DELETE_plopReport: builder.mutation<IPlopReport, string>({
      query: (id) => ({
        url: `/plop-reports/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['plop-reports'],
    }),
    PUT_plopReportSendStudent: builder.mutation<any, any>({
      query: (id) => ({
        url: `/plop-reports/${id}/send-to-student/`,
        method: 'PUT',
      }),
      invalidatesTags: ['plop-reports', 'plop-report'],
    }),
    PUT_plopReportSendParents: builder.mutation<any, any>({
      query: (id) => ({
        url: `/plop-reports/${id}/send-to-parents/`,
        method: 'PUT',
      }),
      invalidatesTags: ['plop-reports', 'plop-report'],
    }),
    GET_plopPerformance: builder.query<any, void>({
      query: () => ({
        url: '/plop-reports/performance/',
      }),
    }),
    GET_plopStats: builder.query<IPlopStats[], IPlopStatsParams>({
      query: (params) => ({
        url: '/plop/stats/',
        params
      }),
      providesTags: ['plop-reports'],
    }),
    GET_plopCategories: builder.query<any, void>({
      query: () => ({
        url: '/plop-categories/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['plop-categories'],
    }),
    GET_plopQuestionCategories: builder.query<any, void>({
      query: () => ({
        url: '/plop-question-categories/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['plop-question-categories'],
    }),
    GET_plopCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/plop-categories/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['plop-categories'],
    }),

  }),

})

export const { 
  useGET_plopQuestionCategoriesQuery,
  useGET_plopCategoriesQuery,
  useGET_plopCategoriesSelectQuery,
  useGET_plopReportsQuery,
  useGET_plopReportByIdQuery,
  useGET_plopPerformanceQuery,
  useGET_plopStatsQuery,
  usePOST_plopReportMutation, 
  usePATCH_plopReportMutation, 
  useDELETE_plopReportMutation,
  usePUT_plopReportSendStudentMutation, 
  usePUT_plopReportSendParentsMutation, 
} = plopAPI
